import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import { Toaster } from "sonner";

export default function Layout() {
  const { pathname } = useLocation();
  const isAdminDashboard = pathname === "/admin/dashboard";

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1" data-testid="main-content">
        <Outlet />
      </main>
      {!isAdminDashboard && <Footer />}
      <WhatsAppFloat />
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}
